import { SearchFieldOption } from 'components/common/types/DirectSalesCampaign.types';

export const columnIds: Record<string, SearchFieldOption> = {
  status: 'CAMPAIGN_STATUS',
  campaignName: 'CAMPAIGN_NAME',
  userVisibleId: 'USER_VISIBLE_ID',
  startDate: 'START_DATE',
  endDate: 'END_DATE',
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT',
  salesTeam: 'SALES_TEAM',
  salesPerson: 'SALES_PERSON',
  adminPerson: 'ADMIN_PERSON',
  advertiser: 'ADVERTISER',
  brand: 'BRAND',
  productCategory: 'PRODUCT_CATEGORY',
  agency: 'AGENCY',
  specialist: 'SPECIALIST',
  updatedBy: 'UPDATED_BY',
  dropDate: 'DROP_DATE',
  createdBy: 'CREATED_BY',
};

export const sortColumnsBy = (columnId: string): SearchFieldOption | undefined => {
  return columnIds[columnId];
};
